module.exports = __webpack_public_path__ + "img/check-circle-white.e79d77ce.svg";